import React from 'react'
import SearchCriteriaStore from '@App/stores/search/search-criteria-store'
import CriterionRow from '@Components/Search/SearchWithCriteria/CriterionRow'
import { SearchCriterion } from '@App/stores/search/models/search-criterion'
import { observer } from 'mobx-react'
import { FieldArrayWithId } from 'react-hook-form'

interface CriteriaRowsProps<T extends object> {
    searchCriteriaStore: SearchCriteriaStore<T>
    fields: Array<FieldArrayWithId<{ search: Array<SearchCriterion<T>> }, 'search', 'fieldId'>>
    disableAutoComplete?: boolean
}

const CriteriaRows = <T extends object>({ searchCriteriaStore, disableAutoComplete, fields }: CriteriaRowsProps<T>) => (
    <>
        {fields.map((field, index) => (
            <CriterionRow
                criterion={field}
                searchCriteriaStore={searchCriteriaStore}
                key={field.fieldId}
                index={index}
                disableAutoComplete={disableAutoComplete}
            />
        ))}
    </>
)

export default observer(CriteriaRows)
